<template>
  <OptionInput
    type="checkbox"
    :value="option.label"
    :modelValue="modelValue"
    :updateFn="updateValue"
    :option="option"
    :maxOptions="maxOptions"
    class="option-input--checkbox"
  >
    <span class="option-input__label">
      {{ option.label }}
    </span>
  </OptionInput>
</template>

<script setup lang="ts">
import { QuestionnaireFormOption } from '@/models/onboarding.types'
import OptionInput from './OptionInput.vue'

const props = defineProps<{
  modelValue: string[]
  option: QuestionnaireFormOption
  maxOptions?: number
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string[]): void
}>()

function updateValue(event: Event): void {
  const input = event.target as HTMLInputElement
  if (!input) {
    return
  }
  const newValue = [...props.modelValue]

  if (input.checked) {
    newValue.push(input.value)
  } else {
    const index = newValue.indexOf(input.value)
    if (index !== -1) {
      newValue.splice(index, 1)
    }
  }

  emit('update:modelValue', newValue)
}
</script>
